// Murray Road Map Configuration
// This file contains the map settings for restricting the view to Murray Road between Sydney Road and Gilbert Road

export const MURRAY_ROAD_MAP_CONFIG = {
  // Map center coordinates (midpoint of Murray Road section)
  center: {
    lat: -37.735426,
    lng: 144.977563,
  },

  // Optimal zoom level for Murray Road section
  zoom: 13,

  // Map bounds to restrict navigation - Murray Road area
  bounds: {
    north: -37.725, // Northern boundary (expanded further)
    south: -37.745, // Southern boundary (expanded further)
    east: 145.005, // Eastern boundary (Gilbert Rd area - extended)
    west: 144.96, // Western boundary (Sydney Rd area - extended further west)
  },

  // Intersection points for reference
  intersections: {
    sydneyRoad: {
      lat: -37.73619,
      lng: 144.980267,
      name: 'Sydney Road & Murray Road',
    },
    gilbertRoad: {
      lat: -37.73619,
      lng: 144.999621,
      name: 'Gilbert Road & Murray Road',
    },
  },

  // Map restriction settings - Murray Road bounds
  restriction: {
    latLngBounds: {
      north: -37.725, // Northern boundary (expanded further)
      south: -37.745, // Southern boundary (expanded further)
      east: 145.005, // Eastern boundary (Gilbert Rd area - extended)
      west: 144.96, // Western boundary (Sydney Rd area - extended further west)
    },
    strictBounds: false,
  },

  // Map styling options
  mapStyles: [
    {
      featureType: 'poi',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'transit',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
    {
      featureType: 'poi.business',
      elementType: 'labels',
      stylers: [{ visibility: 'off' }],
    },
  ],

  // Map control options
  mapOptions: {
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    clickableIcons: false,
    gestureHandling: 'cooperative',
    disableDefaultUI: true,
    zoomControl: true,
  },
};

// Helper function to get map configuration with dynamic restrictions
export function getMurrayRoadMapConfig(dynamicConfig = null) {
  // Use dynamic config if provided, otherwise fall back to static config
  const config = dynamicConfig || MURRAY_ROAD_MAP_CONFIG;

  return {
    ...config,
    options: {
      ...config.mapOptions,
      restriction: dynamicConfig?.restriction || config.restriction,
      styles: dynamicConfig?.mapStyles || config.mapStyles,
    },
  };
}

// Helper function to check if coordinates are within Murray Road bounds
export function isWithinMurrayRoadBounds(lat, lng) {
  const { bounds } = MURRAY_ROAD_MAP_CONFIG;
  return lat >= bounds.south && lat <= bounds.north && lng >= bounds.west && lng <= bounds.east;
}

// Helper function to get distance from Murray Road center
export function getDistanceFromMurrayRoadCenter(lat, lng) {
  const { center } = MURRAY_ROAD_MAP_CONFIG;
  const R = 6371; // Earth's radius in kilometers
  const dLat = ((lat - center.lat) * Math.PI) / 180;
  const dLng = ((lng - center.lng) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos((center.lat * Math.PI) / 180) *
      Math.cos((lat * Math.PI) / 180) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in kilometers
}

export default MURRAY_ROAD_MAP_CONFIG;
